import { ButtonType, ButtonWidget, DialogFooterButtonsWidget, DialogPositioningBehavior, DialogProps, DialogType, DialogWidget, ToastType, ToastWidget } from '@tableau/widgets';
import React from 'react';

import { Messages } from '~src/codegen/Localize';
import { CloseAndDismiss, ReactModalService } from '~src/commonInfra/dialogs/ReactModalService';
import { TabDialogWidth } from '~src/commonInfra/dialogs/style/TabDialogWidth';

import CustomDomainHttpClient from '../serverAPI/CustomDomainHttpClient';
import { UpdateCustomDomainRequest } from '../serverAPI/requests/AddOrUpdateCustomDomainRequest';
import { deleteCustomDomainSetting } from '../serverAPI/requests/DeleteCustomDomainRequest';
import { AddOrUpdateCustomDomainSettingRequest, CustomDomainSettingResponse } from '../serverAPI/types/CustomDomainTypes';
import { configuredSettingButtonStyle, configuredSettingContentStyle, configuredSettingHeaderStyle, configuredSettingValueStyle, customDomainContentStyle } from '../styles/CustomDomainStyles';
import { FileUpload } from './FileUpload';


export interface ConfiguredCustomDomainState {
    isUploading: boolean;
  }

export interface ConfiguredCustomDomainProps {
    customDomainSetting: CustomDomainSettingResponse;
    triggerFetchCustomDomain(): void;
  }

export class ConfiguredCustomDomainView extends React.PureComponent<ConfiguredCustomDomainProps, ConfiguredCustomDomainState> {
    public constructor(props: ConfiguredCustomDomainProps) {
        super(props);
        this.state = {
            isUploading: false
        };
      }

      private removeDomain = (): void => {
        deleteCustomDomainSetting(this.props.customDomainSetting.site_luid).then((res: CustomDomainSettingResponse)  => {
           this.props.triggerFetchCustomDomain();
         }).catch(err => {
           ToastWidget.show({
            message: Messages.CustomDomainSetting_deleteDomainFailedToast(),
            testId: 'toast-validate-cname-operation-failed',
            toastType: ToastType.Error,
          });
         });
      };

      private uploadSslCertificate = (selectedFile: File): void => {
        //Fetch TLS cert and privateKey from this and send it using an API call.
        const customDomainSetting: AddOrUpdateCustomDomainSettingRequest = {
          site_luid: this.props.customDomainSetting.site_luid,
          custom_domain: this.props.customDomainSetting.custom_domain,
          status: this.props.customDomainSetting.status,
          tls_certificate: '',
          tls_certificate_private_key: ''
        };
        this.setState({isUploading: true});

        CustomDomainHttpClient.requestPutOrPost(new UpdateCustomDomainRequest(customDomainSetting)).then((res: CustomDomainSettingResponse)  => {
           ToastWidget.show({
            message: Messages.CustomDomainSetting_uploadSslCertSucceededToast(),
            testId: 'toast-upload-cert-success',
            toastType: ToastType.Success,
            });
           this.props.triggerFetchCustomDomain();
        }).catch(err => {
           ToastWidget.show({
            message: Messages.CustomDomainSetting_uploadSslCertFailedToast(),
            testId: 'toast-upload-cert-failed',
            toastType: ToastType.Error,
          });
        }).finally(() => {
          this.setState({isUploading: false});
        });
      };

      private getFooterContent = (closeAndDismiss: CloseAndDismiss): React.ReactNode => {
        return (
          <>
          <DialogFooterButtonsWidget
            buttons={[
              {
                handleClick: () => {
                  //show pop up and proceed only if 'remove' button is clicked
                  closeAndDismiss.close();
                  this.removeDomain();
                },
                buttonType: ButtonType.Destructive,
                children: Messages.CustomDomainSetting_RemoveDialogButton(),
                testId: 'footer-remove',
              }
            ]}
          />
          </>
        );
      };

      private getDialogWidget = (dialogProps: DialogProps)=> {
        return (
          <DialogWidget {...dialogProps}>
            <div className={customDomainContentStyle}>
              {Messages.CustomDomainSetting_removeDomainDialog()}
            </div>
          </DialogWidget>
        );
      };

      private openDialog= (): void => {
        ReactModalService.openCustom(closeAndDismiss => {
          const dialogProps = ReactModalService.getDefaultDialogProps({
            type: DialogType.NormalWithTitleBar,
            title: Messages.CustomDomainSetting_removeDomainLabel(),
            testId: 'remove-domain-dialog',
            showCloseButton: true,
            dialogWidth: TabDialogWidth.width375px,
            positioningBehavior: DialogPositioningBehavior.Draggable,
            footerContent: this.getFooterContent(closeAndDismiss)
          }, closeAndDismiss);
          return this.getDialogWidget(dialogProps);
        });
      };

      private renderConfiguredCustomDomainView() {
        return (
              <>
                <div className={configuredSettingValueStyle}>
                  <strong>{Messages.CustomDomainSetting_configuredCustomDomain({'CUSTOM_DOMAIN': this.props.customDomainSetting.custom_domain})}</strong>
                </div>
                <div className={configuredSettingValueStyle}>
                  <strong>{Messages.CustomDomainSetting_configuredTableauDomain({'TABLEAU_DOMAIN': this.props.customDomainSetting.intermediate_domain})}</strong>
                </div>
                <div className={configuredSettingValueStyle}>
                  <strong>{Messages.CustomDomainSetting_configuredSslExpiry({'SSL_EXPIRY': this.props.customDomainSetting.tls_certificate_expiry_date.toUTCString()})}</strong>
                </div>
               </>
            );
      }

    public render() {
        return <>
            <div>
                <strong className={configuredSettingHeaderStyle}>{Messages.CustomDomainSetting_currentConfigurationTitle()}</strong>
            </div>
            <div className={configuredSettingContentStyle}>
              {this.renderConfiguredCustomDomainView()}
            </div>
            <div className={configuredSettingContentStyle}>
                <ButtonWidget buttonType={ButtonType.Destructive} onClick={this.openDialog} testId='button-remove-domain' className={configuredSettingButtonStyle}>
                  {Messages.CustomDomainSetting_removeDomainLabel()}
                </ButtonWidget>
                <FileUpload promptText={Messages.CustomDomainSetting_replaceSslButton()} tbTestId='button-replace-ssl' onFileSelect={this.uploadSslCertificate}/>
            </div>
        </>;
    }
}